import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { CustomersService } from '../customers.service';
import * as customersActions from './customers.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Customers } from '../../_models/customers';
import { User } from '../../_models/user';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';

@Injectable()
export class CustomersEffects {

    @Effect()
    loadCustomers$ = this.actions$.pipe(
        ofType(customersActions.CustomersActitonTypes.LoadCustomerss),
        mergeMap((action: customersActions.LoadCustomerss) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadCustomerss =');
                // console.log(action.payload);

                return this.customersService.getCustomerss(action.payload).pipe(
                    map((customerss: Customers[]) => {
                        this.changingLoading(false);
                        return new customersActions.LoadCustomerssSuccess(customerss);
                    }),
                    catchError(err => of(new customersActions.LoadCustomerssFail(err)))
                )
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadCustomersSuccess$ = this.actions$.pipe(
    //     ofType(customersActions.CustomersActitonTypes.LoadCustomerssSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateCustomers$: Observable<Action> = this.actions$.pipe(
    //     ofType(customersActions.CustomersActitonTypes.UpdateCustomers),
    //     map((action: customersActions.UpdateCustomers) => action.payload),
    //     mergeMap(( customers: Customers) =>
    //         this.customersService.updateCustomers(customers).pipe(
    //         map(updatedCustomers => (new customersActions.UpdateCustomersSuccess(updatedCustomers))),
    //         catchError(err => of(new customersActions.UpdateCustomersFail(err)))
    //     ))
    // );

    @Effect()
    updateCustomers$ = this.actions$.pipe(
        ofType(customersActions.CustomersActitonTypes.UpdateCustomers),
        mergeMap((action: customersActions.UpdateCustomers) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateCustomers =');
                // console.log(action.payload);

                return this.customersService.updateCustomers(action.payload).pipe(
                    map((customers: Customers) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateCustomers =');
                        console.log(customers);
                        if (customers !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/customers', null, 'info');
                            return new customersActions.UpdateCustomersSuccess(customers);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new customersActions.UpdateCustomersFail('ERROR UpdateCustomers effect.');
                        }
                    }),
                    catchError(err => of(new customersActions.UpdateCustomersFail(err)))
                )
            }
        )
    );


    // @Effect()
    // createCustomers$: Observable<Action> = this.actions$.pipe(
    //     ofType(customersActions.CustomersActitonTypes.CreateCustomers),
    //     map((action: customersActions.CreateCustomers) => action.payload),
    //     mergeMap(( customers: Customers) =>
    //         this.customersService.createCustomers(customers).pipe(
    //         map(createCustomers => (new customersActions.CreateCustomersSuccess(createCustomers))),
    //         catchError(err => of(new customersActions.CreateCustomersFail(err)))
    //     ))
    // );

    @Effect()
    CreateCustomers$ = this.actions$.pipe(
        ofType(customersActions.CustomersActitonTypes.CreateCustomers),
        mergeMap((action: customersActions.CreateCustomers) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateCustomers =');
                // console.log(action.payload);

                return this.customersService.createCustomers(action.payload).pipe(
                    map((customers: Customers) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateCustomers =');
                        // console.log(customers);
                        if (customers !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/customers', null, 'info');
                            return new customersActions.CreateCustomersSuccess(customers);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new customersActions.CreateCustomersFail('ERROR CreateCustomers effect.');
                        }
                    }),
                    catchError(err => of(new customersActions.CreateCustomersFail(err)))
                )
            }
        )
    );

    // @Effect()
    // deleteCustomers$: Observable<Action> = this.actions$.pipe(
    //     ofType(customersActions.CustomersActitonTypes.DeleteCustomers),
    //     map((action: customersActions.DeleteCustomers) => action.payload),
    //     mergeMap(( customers: Customers) =>
    //         this.customersService.deleteCustomers(customers).pipe(
    //         map(deleteCustomersId => (new customersActions.DeleteCustomersSuccess(deleteCustomersId))),
    //         catchError(err => of(new customersActions.DeleteCustomersFail(err)))
    //     ))
    // );

    @Effect()
    deleteCustomers$ = this.actions$.pipe(
        ofType(customersActions.CustomersActitonTypes.DeleteCustomers),
        mergeMap((action: customersActions.DeleteCustomers) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteCustomers =');
                // console.log(action.payload);

                return this.customersService.deleteCustomers(action.payload).pipe(
                    map((customersId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteCustomers =');
                        console.log(customersId);
                        if (customersId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new customersActions.DeleteCustomersSuccess(customersId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new customersActions.DeleteCustomersFail('ERROR DeleteCustomers effect.');
                        }
                    }),
                    catchError(err => of(new customersActions.DeleteCustomersFail(err)))
                )
            }
        )
    );

    @Effect()
    loadUsers$ = this.actions$.pipe(
        ofType(customersActions.CustomersActitonTypes.LoadUsers),
        mergeMap((action: customersActions.LoadUsers) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadUsers =');
                // console.log(action.payload);

                return this.customersService.getUsers().pipe(
                    map((users: User[]) => {
                        this.changingLoading(false);
                        return new customersActions.LoadUsersSuccess(users);
                    }),
                    catchError(err => of(new customersActions.LoadUsersFail(err)))
                )
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private customersService: CustomersService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Customers Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
